<template lang="pug">
.admin-upload
  file-article-creation-form(
    ref="form"
    @submit-succeed="successAlert = true")
  v-alert(
    v-model="successAlert"
    dismissible
    type="success") 上傳成功  
</template>
<script>
import { storage } from "@/firebase";
import FileArticleCreationForm from "@/components/forms/FileArticleCreationForm.vue";

export default {
  name: "AdminUpload",
  components: {
    FileArticleCreationForm
  },
  data() {
    return {
      loading: false,
      successAlert: false
    };
  }
};
</script>
